/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClassInsightsResponse } from '../models';
// @ts-ignore
import type { ClassMemberResponse } from '../models';
// @ts-ignore
import type { ClassMembersResponse } from '../models';
// @ts-ignore
import type { CreateClassBody } from '../models';
// @ts-ignore
import type { CreatePostBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExtractEmailsResponse } from '../models';
// @ts-ignore
import type { GetAllClassesResponse } from '../models';
// @ts-ignore
import type { GetClassResponse } from '../models';
// @ts-ignore
import type { InviteMembersBody } from '../models';
// @ts-ignore
import type { InviteMembersResponse } from '../models';
// @ts-ignore
import type { PostAttachmentResponse } from '../models';
// @ts-ignore
import type { PostResponse } from '../models';
// @ts-ignore
import type { PostsResponse } from '../models';
// @ts-ignore
import type { StudentInsightsResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { TransferClassBody } from '../models';
// @ts-ignore
import type { UpdateClassBody } from '../models';
/**
 * FacultyClassApiApi - axios parameter creator
 */
export const FacultyClassApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateClassBody} createClassBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiCreateClass: async (createClassBody: CreateClassBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClassBody' is not null or undefined
            assertParamExists('facultyClassApiCreateClass', 'createClassBody', createClassBody)
            const localVarPath = `/api/v1/faculty/classes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClassBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {CreatePostBody} createPostBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiCreatePost: async (classId: string, createPostBody: CreatePostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiCreatePost', 'classId', classId)
            // verify required parameter 'createPostBody' is not null or undefined
            assertParamExists('facultyClassApiCreatePost', 'createPostBody', createPostBody)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/posts`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiDeleteClass: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiDeleteClass', 'classId', classId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiDeletePost: async (classId: string, postId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiDeletePost', 'classId', classId)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('facultyClassApiDeletePost', 'postId', postId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/posts/{post_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{post_id}', encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {File} rosterFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiExtractEmails: async (classId: string, rosterFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiExtractEmails', 'classId', classId)
            // verify required parameter 'rosterFile' is not null or undefined
            assertParamExists('facultyClassApiExtractEmails', 'rosterFile', rosterFile)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/members/extract-emails`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (rosterFile !== undefined) { 
                localVarFormParams.append('roster_file', rosterFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetClass: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiGetClass', 'classId', classId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {FacultyClassApiGetClassGradebookFormatEnum} format 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetClassGradebook: async (classId: string, format: FacultyClassApiGetClassGradebookFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiGetClassGradebook', 'classId', classId)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('facultyClassApiGetClassGradebook', 'format', format)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/gradebook`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetClassInsights: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiGetClassInsights', 'classId', classId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/insights`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetStudentInsights: async (classId: string, memberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiGetStudentInsights', 'classId', classId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('facultyClassApiGetStudentInsights', 'memberId', memberId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/students/{member_id}/insights`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{member_id}', encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {InviteMembersBody} inviteMembersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiInviteMembers: async (classId: string, inviteMembersBody: InviteMembersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiInviteMembers', 'classId', classId)
            // verify required parameter 'inviteMembersBody' is not null or undefined
            assertParamExists('facultyClassApiInviteMembers', 'inviteMembersBody', inviteMembersBody)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/members`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteMembersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiListClasses: async (page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/classes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {FacultyClassApiListMembersRoleEnum} [role] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiListMembers: async (classId: string, page?: number, pageSize?: number, role?: FacultyClassApiListMembersRoleEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiListMembers', 'classId', classId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/members`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiListPosts: async (classId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiListPosts', 'classId', classId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/posts`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiRemoveMember: async (classId: string, memberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiRemoveMember', 'classId', classId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('facultyClassApiRemoveMember', 'memberId', memberId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/members/{member_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{member_id}', encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiResendInvite: async (classId: string, memberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiResendInvite', 'classId', classId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('facultyClassApiResendInvite', 'memberId', memberId)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/members/{member_id}/resend`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{member_id}', encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {TransferClassBody} transferClassBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiTransferClass: async (classId: string, transferClassBody: TransferClassBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiTransferClass', 'classId', classId)
            // verify required parameter 'transferClassBody' is not null or undefined
            assertParamExists('facultyClassApiTransferClass', 'transferClassBody', transferClassBody)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/owner`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferClassBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {UpdateClassBody} updateClassBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiUpdateClass: async (classId: string, updateClassBody: UpdateClassBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiUpdateClass', 'classId', classId)
            // verify required parameter 'updateClassBody' is not null or undefined
            assertParamExists('facultyClassApiUpdateClass', 'updateClassBody', updateClassBody)
            const localVarPath = `/api/v1/faculty/classes/{class_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClassBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} postId 
         * @param {CreatePostBody} createPostBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiUpdatePost: async (classId: string, postId: string, createPostBody: CreatePostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiUpdatePost', 'classId', classId)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('facultyClassApiUpdatePost', 'postId', postId)
            // verify required parameter 'createPostBody' is not null or undefined
            assertParamExists('facultyClassApiUpdatePost', 'createPostBody', createPostBody)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/posts/{post_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{post_id}', encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {File} attachmentFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiUploadPostAttachment: async (classId: string, attachmentFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('facultyClassApiUploadPostAttachment', 'classId', classId)
            // verify required parameter 'attachmentFile' is not null or undefined
            assertParamExists('facultyClassApiUploadPostAttachment', 'attachmentFile', attachmentFile)
            const localVarPath = `/api/v1/faculty/classes/{class_id}/posts/attachments`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (attachmentFile !== undefined) { 
                localVarFormParams.append('attachment_file', attachmentFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacultyClassApiApi - functional programming interface
 */
export const FacultyClassApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacultyClassApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateClassBody} createClassBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiCreateClass(createClassBody: CreateClassBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiCreateClass(createClassBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiCreateClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {CreatePostBody} createPostBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiCreatePost(classId: string, createPostBody: CreatePostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiCreatePost(classId, createPostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiDeleteClass(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiDeleteClass(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiDeleteClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} postId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiDeletePost(classId: string, postId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiDeletePost(classId, postId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {File} rosterFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiExtractEmails(classId: string, rosterFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiExtractEmails(classId, rosterFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiExtractEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiGetClass(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiGetClass(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiGetClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {FacultyClassApiGetClassGradebookFormatEnum} format 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiGetClassGradebook(classId: string, format: FacultyClassApiGetClassGradebookFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiGetClassGradebook(classId, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiGetClassGradebook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiGetClassInsights(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiGetClassInsights(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiGetClassInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiGetStudentInsights(classId: string, memberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiGetStudentInsights(classId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiGetStudentInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {InviteMembersBody} inviteMembersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiInviteMembers(classId: string, inviteMembersBody: InviteMembersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiInviteMembers(classId, inviteMembersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiInviteMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiListClasses(page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllClassesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiListClasses(page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiListClasses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {FacultyClassApiListMembersRoleEnum} [role] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiListMembers(classId: string, page?: number, pageSize?: number, role?: FacultyClassApiListMembersRoleEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiListMembers(classId, page, pageSize, role, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiListMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiListPosts(classId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiListPosts(classId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiListPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiRemoveMember(classId: string, memberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiRemoveMember(classId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiRemoveMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiResendInvite(classId: string, memberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassMemberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiResendInvite(classId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiResendInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {TransferClassBody} transferClassBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiTransferClass(classId: string, transferClassBody: TransferClassBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiTransferClass(classId, transferClassBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiTransferClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {UpdateClassBody} updateClassBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiUpdateClass(classId: string, updateClassBody: UpdateClassBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiUpdateClass(classId, updateClassBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiUpdateClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} postId 
         * @param {CreatePostBody} createPostBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiUpdatePost(classId: string, postId: string, createPostBody: CreatePostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiUpdatePost(classId, postId, createPostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {File} attachmentFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyClassApiUploadPostAttachment(classId: string, attachmentFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAttachmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyClassApiUploadPostAttachment(classId, attachmentFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyClassApiApi.facultyClassApiUploadPostAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacultyClassApiApi - factory interface
 */
export const FacultyClassApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacultyClassApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiCreateClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiCreateClass(requestParameters: FacultyClassApiApiFacultyClassApiCreateClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClassResponse> {
            return localVarFp.facultyClassApiCreateClass(requestParameters.createClassBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiCreatePost(requestParameters: FacultyClassApiApiFacultyClassApiCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostResponse> {
            return localVarFp.facultyClassApiCreatePost(requestParameters.classId, requestParameters.createPostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiDeleteClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiDeleteClass(requestParameters: FacultyClassApiApiFacultyClassApiDeleteClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyClassApiDeleteClass(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiDeletePost(requestParameters: FacultyClassApiApiFacultyClassApiDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyClassApiDeletePost(requestParameters.classId, requestParameters.postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiExtractEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiExtractEmails(requestParameters: FacultyClassApiApiFacultyClassApiExtractEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractEmailsResponse> {
            return localVarFp.facultyClassApiExtractEmails(requestParameters.classId, requestParameters.rosterFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiGetClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetClass(requestParameters: FacultyClassApiApiFacultyClassApiGetClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClassResponse> {
            return localVarFp.facultyClassApiGetClass(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiGetClassGradebookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetClassGradebook(requestParameters: FacultyClassApiApiFacultyClassApiGetClassGradebookRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.facultyClassApiGetClassGradebook(requestParameters.classId, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiGetClassInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetClassInsights(requestParameters: FacultyClassApiApiFacultyClassApiGetClassInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassInsightsResponse> {
            return localVarFp.facultyClassApiGetClassInsights(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiGetStudentInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiGetStudentInsights(requestParameters: FacultyClassApiApiFacultyClassApiGetStudentInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<StudentInsightsResponse> {
            return localVarFp.facultyClassApiGetStudentInsights(requestParameters.classId, requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiInviteMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiInviteMembers(requestParameters: FacultyClassApiApiFacultyClassApiInviteMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteMembersResponse> {
            return localVarFp.facultyClassApiInviteMembers(requestParameters.classId, requestParameters.inviteMembersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiListClassesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiListClasses(requestParameters: FacultyClassApiApiFacultyClassApiListClassesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllClassesResponse> {
            return localVarFp.facultyClassApiListClasses(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiListMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiListMembers(requestParameters: FacultyClassApiApiFacultyClassApiListMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassMembersResponse> {
            return localVarFp.facultyClassApiListMembers(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.role, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiListPostsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiListPosts(requestParameters: FacultyClassApiApiFacultyClassApiListPostsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostsResponse> {
            return localVarFp.facultyClassApiListPosts(requestParameters.classId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiRemoveMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiRemoveMember(requestParameters: FacultyClassApiApiFacultyClassApiRemoveMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyClassApiRemoveMember(requestParameters.classId, requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiResendInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiResendInvite(requestParameters: FacultyClassApiApiFacultyClassApiResendInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassMemberResponse> {
            return localVarFp.facultyClassApiResendInvite(requestParameters.classId, requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiTransferClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiTransferClass(requestParameters: FacultyClassApiApiFacultyClassApiTransferClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClassResponse> {
            return localVarFp.facultyClassApiTransferClass(requestParameters.classId, requestParameters.transferClassBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiUpdateClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiUpdateClass(requestParameters: FacultyClassApiApiFacultyClassApiUpdateClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClassResponse> {
            return localVarFp.facultyClassApiUpdateClass(requestParameters.classId, requestParameters.updateClassBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiUpdatePost(requestParameters: FacultyClassApiApiFacultyClassApiUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostResponse> {
            return localVarFp.facultyClassApiUpdatePost(requestParameters.classId, requestParameters.postId, requestParameters.createPostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyClassApiApiFacultyClassApiUploadPostAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyClassApiUploadPostAttachment(requestParameters: FacultyClassApiApiFacultyClassApiUploadPostAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostAttachmentResponse> {
            return localVarFp.facultyClassApiUploadPostAttachment(requestParameters.classId, requestParameters.attachmentFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facultyClassApiCreateClass operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiCreateClassRequest {
    readonly createClassBody: CreateClassBody
}

/**
 * Request parameters for facultyClassApiCreatePost operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiCreatePostRequest {
    readonly classId: string

    readonly createPostBody: CreatePostBody
}

/**
 * Request parameters for facultyClassApiDeleteClass operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiDeleteClassRequest {
    readonly classId: string
}

/**
 * Request parameters for facultyClassApiDeletePost operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiDeletePostRequest {
    readonly classId: string

    readonly postId: string
}

/**
 * Request parameters for facultyClassApiExtractEmails operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiExtractEmailsRequest {
    readonly classId: string

    readonly rosterFile: File
}

/**
 * Request parameters for facultyClassApiGetClass operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiGetClassRequest {
    readonly classId: string
}

/**
 * Request parameters for facultyClassApiGetClassGradebook operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiGetClassGradebookRequest {
    readonly classId: string

    readonly format: FacultyClassApiGetClassGradebookFormatEnum
}

/**
 * Request parameters for facultyClassApiGetClassInsights operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiGetClassInsightsRequest {
    readonly classId: string
}

/**
 * Request parameters for facultyClassApiGetStudentInsights operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiGetStudentInsightsRequest {
    readonly classId: string

    readonly memberId: string
}

/**
 * Request parameters for facultyClassApiInviteMembers operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiInviteMembersRequest {
    readonly classId: string

    readonly inviteMembersBody: InviteMembersBody
}

/**
 * Request parameters for facultyClassApiListClasses operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiListClassesRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly search?: string
}

/**
 * Request parameters for facultyClassApiListMembers operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiListMembersRequest {
    readonly classId: string

    readonly page?: number

    readonly pageSize?: number

    readonly role?: FacultyClassApiListMembersRoleEnum

    readonly search?: string
}

/**
 * Request parameters for facultyClassApiListPosts operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiListPostsRequest {
    readonly classId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for facultyClassApiRemoveMember operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiRemoveMemberRequest {
    readonly classId: string

    readonly memberId: string
}

/**
 * Request parameters for facultyClassApiResendInvite operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiResendInviteRequest {
    readonly classId: string

    readonly memberId: string
}

/**
 * Request parameters for facultyClassApiTransferClass operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiTransferClassRequest {
    readonly classId: string

    readonly transferClassBody: TransferClassBody
}

/**
 * Request parameters for facultyClassApiUpdateClass operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiUpdateClassRequest {
    readonly classId: string

    readonly updateClassBody: UpdateClassBody
}

/**
 * Request parameters for facultyClassApiUpdatePost operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiUpdatePostRequest {
    readonly classId: string

    readonly postId: string

    readonly createPostBody: CreatePostBody
}

/**
 * Request parameters for facultyClassApiUploadPostAttachment operation in FacultyClassApiApi.
 */
export interface FacultyClassApiApiFacultyClassApiUploadPostAttachmentRequest {
    readonly classId: string

    readonly attachmentFile: File
}

/**
 * FacultyClassApiApi - object-oriented interface
 */
export class FacultyClassApiApi extends BaseAPI {
    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiCreateClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiCreateClass(requestParameters: FacultyClassApiApiFacultyClassApiCreateClassRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiCreateClass(requestParameters.createClassBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiCreatePost(requestParameters: FacultyClassApiApiFacultyClassApiCreatePostRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiCreatePost(requestParameters.classId, requestParameters.createPostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiDeleteClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiDeleteClass(requestParameters: FacultyClassApiApiFacultyClassApiDeleteClassRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiDeleteClass(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiDeletePost(requestParameters: FacultyClassApiApiFacultyClassApiDeletePostRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiDeletePost(requestParameters.classId, requestParameters.postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiExtractEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiExtractEmails(requestParameters: FacultyClassApiApiFacultyClassApiExtractEmailsRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiExtractEmails(requestParameters.classId, requestParameters.rosterFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiGetClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiGetClass(requestParameters: FacultyClassApiApiFacultyClassApiGetClassRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiGetClass(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiGetClassGradebookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiGetClassGradebook(requestParameters: FacultyClassApiApiFacultyClassApiGetClassGradebookRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiGetClassGradebook(requestParameters.classId, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiGetClassInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiGetClassInsights(requestParameters: FacultyClassApiApiFacultyClassApiGetClassInsightsRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiGetClassInsights(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiGetStudentInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiGetStudentInsights(requestParameters: FacultyClassApiApiFacultyClassApiGetStudentInsightsRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiGetStudentInsights(requestParameters.classId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiInviteMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiInviteMembers(requestParameters: FacultyClassApiApiFacultyClassApiInviteMembersRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiInviteMembers(requestParameters.classId, requestParameters.inviteMembersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiListClassesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiListClasses(requestParameters: FacultyClassApiApiFacultyClassApiListClassesRequest = {}, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiListClasses(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiListMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiListMembers(requestParameters: FacultyClassApiApiFacultyClassApiListMembersRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiListMembers(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.role, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiListPostsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiListPosts(requestParameters: FacultyClassApiApiFacultyClassApiListPostsRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiListPosts(requestParameters.classId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiRemoveMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiRemoveMember(requestParameters: FacultyClassApiApiFacultyClassApiRemoveMemberRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiRemoveMember(requestParameters.classId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiResendInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiResendInvite(requestParameters: FacultyClassApiApiFacultyClassApiResendInviteRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiResendInvite(requestParameters.classId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiTransferClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiTransferClass(requestParameters: FacultyClassApiApiFacultyClassApiTransferClassRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiTransferClass(requestParameters.classId, requestParameters.transferClassBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiUpdateClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiUpdateClass(requestParameters: FacultyClassApiApiFacultyClassApiUpdateClassRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiUpdateClass(requestParameters.classId, requestParameters.updateClassBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiUpdatePost(requestParameters: FacultyClassApiApiFacultyClassApiUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiUpdatePost(requestParameters.classId, requestParameters.postId, requestParameters.createPostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyClassApiApiFacultyClassApiUploadPostAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyClassApiUploadPostAttachment(requestParameters: FacultyClassApiApiFacultyClassApiUploadPostAttachmentRequest, options?: RawAxiosRequestConfig) {
        return FacultyClassApiApiFp(this.configuration).facultyClassApiUploadPostAttachment(requestParameters.classId, requestParameters.attachmentFile, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FacultyClassApiGetClassGradebookFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx',
    Pdf: 'pdf',
} as const;
export type FacultyClassApiGetClassGradebookFormatEnum = typeof FacultyClassApiGetClassGradebookFormatEnum[keyof typeof FacultyClassApiGetClassGradebookFormatEnum];
export const FacultyClassApiListMembersRoleEnum = {
    Teacher: 'teacher',
    Assistant: 'assistant',
    Student: 'student',
} as const;
export type FacultyClassApiListMembersRoleEnum = typeof FacultyClassApiListMembersRoleEnum[keyof typeof FacultyClassApiListMembersRoleEnum];
